import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Alert, Button, Card, Center, Loader, Stack, Text, Title } from '@mantine/core';

import { unwrap } from '../api/client';
import { verifyEmail } from '../api/gen';

// Where the confirmation mail lands. The token is in the query string because
// that is what the server put in the link; the page spends it once, on load,
// and then the address is real and the account is a way in.
//
// Reachable signed out, and reachable on a paired device: a second parent
// confirming their address on the family tablet is an ordinary thing, and the
// page must not depend on who is currently at it.
export function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const [state, setState] = useState<'working' | 'done' | 'failed'>('working');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) {
      setState('failed');
      setError('Diesem Link fehlt sein Token.');
      return;
    }
    void (async () => {
      try {
        await unwrap(verifyEmail({ body: { token } }));
        setState('done');
      } catch (err) {
        setError((err as Error).message);
        setState('failed');
      }
    })();
  }, [token]);

  return (
    <Center mih="100vh" p="md">
      <Card withBorder padding="xl" radius="md" w={420} maw="100%">
        <Stack>
          <Title order={3}>Adresse bestätigen</Title>
          {state === 'working' ? <Loader size="sm" /> : null}
          {state === 'done' ? (
            <>
              <Text size="sm">Danke — die Adresse ist bestätigt.</Text>
              <Button component="a" href="/">
                Zur Anmeldung
              </Button>
            </>
          ) : null}
          {state === 'failed' ? (
            <>
              <Alert color="red" variant="light">
                {error}
              </Alert>
              <Text size="sm" c="dimmed">
                Fordere auf der Anmeldeseite eine neue E-Mail an.
              </Text>
              <Button component="a" href="/" variant="light">
                Zur Anmeldung
              </Button>
            </>
          ) : null}
        </Stack>
      </Card>
    </Center>
  );
}
